import { render, staticRenderFns } from "./RealTimeStatistic.vue?vue&type=template&id=e5022062&"
import script from "./RealTimeStatistic.vue?vue&type=script&lang=js&"
export * from "./RealTimeStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports